module.exports = __webpack_public_path__ + "static/media/bts_lalela_170704_002_small.54fa6ddd.jpg";